// extracted by mini-css-extract-plugin
export default {"news":"Newsfp_news__NAhfI","newsHeader":"Newsfp_newsHeader__I+XUb","linkToNews":"Newsfp_linkToNews__xpSZJ","newsContent":"Newsfp_newsContent__NMgWc"};